import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTour } from '@/contexts/Tour.context';

/**
 * Null-renderer that drives route changes as the active tour advances —
 * pushes the current step's path whenever it differs from the current route.
 */
export const TourNavigator = () => {
  const { isActive, steps, currentIndex } = useTour();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (!isActive || !steps.length) return;
    const step = steps[currentIndex];
    if (step?.path && location.pathname !== step.path) {
      history.push(step.path);
    }
  }, [isActive, currentIndex, steps]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
